import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import "./Environment_Condition_Form.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
function Environment_Condition_Form({handleClose}) {
   const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  const instrumentOptions = [
    { value: "thermometer", label: "Thermometer" },
    { value: "hygrometer", label: "Hygrometer" },
    { value: "pressure_gauge", label: "Pressure Gauge" },
  ];

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          {/* ================= DETAILS OF INSTRUMENT USED ================= */}
          <div className="note_text_holder">
            <p className="red_text">Details Of Instrument Used:</p>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Instrument</Form.Label>
                <Select
                  options={instrumentOptions}
                  placeholder="Select Instrument Name"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Unique ID</Form.Label>
                <Form.Control placeholder="Enter Unique ID" />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Calibration Certificate No</Form.Label>
                <Form.Control placeholder="Enter Certificate No" />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="form_group">
                <Form.Label>Calibration Valid Up To</Form.Label>
                <Form.Control type="date" />
              </Form.Group>
            </div>
          </div>

          <hr />

          {/* ================= ENVIRONMENTAL CONDITION ================= */}

          <div className="note_text_holder">
            <p className="red_text">Record Environmental Condition :</p>
          </div>

          <Form.Group className="form_group">
            <Form.Label>
              Date: <strong>12/12/2025</strong>
            </Form.Label>
          </Form.Group>

          <div className="row">
            {/* Lab Room */}
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <Form.Group className="form_group ">
                    <Form.Label>Lab Room</Form.Label>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form_group flex-fill">
                    <Form.Label>
                      <b>Temp (0 C)</b>
                    </Form.Label>
                    <Form.Control placeholder="Enter Temp" />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form_group flex-fill">
                    <Form.Label>
                      <b>RH (%)</b>
                    </Form.Label>
                    <Form.Control placeholder="Enter RH" />
                  </Form.Group>
                </div>
              </div>
            </div>

            {/* Furnace Room */}
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-12">
                  <Form.Group className="form_group ">
                    <Form.Label>Furnace Room</Form.Label>
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form_group flex-fill">
                    <Form.Label>
                      <b>Temp (0 C)</b>
                    </Form.Label>
                    <Form.Control placeholder="Enter Temp" />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="form_group flex-fill">
                    <Form.Label>
                      <b>RH (%)</b>
                    </Form.Label>
                    <Form.Control placeholder="Enter RH" />
                  </Form.Group>
                </div>
              </div>
            </div>
          </div>

          <div className="add_another_holder">
            <div>
              <span>
                <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
              </span>
            </div>
          </div>

          {/* ================= ACTION BUTTONS ================= */}
          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Environment_Condition_Form;
